import React from "react";
import Box, { BoxProps } from "../Box";
import Text from "../Text";
import Button from "../Button";
import Tooltip from "../Tooltip";

type Props = {
  id?: string;
  text: string;
  font?: string;
  background?: string;
  textColor?: string;
  tooltip?: string | React.ReactNode;
  styleOverrides?: BoxProps;
};

export const Badge: React.FC<Props> = ({
  id,
  text,
  font = "ui.smallBold",
  textColor = "white",
  background = "info",
  tooltip,
  styleOverrides,
}) => {
  return (
    <>
      <Box
        background={background}
        p="2px 4px"
        borderRadius="default"
        data-tooltip-source={id}
        {...styleOverrides}>
        <Text font={font} color={textColor}>
          {text}
        </Text>
      </Box>
      {tooltip && (
        <Tooltip
          border="none"
          direction={Tooltip.Direction.Bottom}
          source={id}
          minWidth="40"
          maxWidth="250">
          <Text color="white" font="ui.small">
            {tooltip}{" "}
            <Button
              fontStyle="ui.smallBold"
              size="small"
              buttonStyle="tertiary"
              link="/pricing"
              text="View plans"
              themeOverrides={{ primaryColor: "white", primaryColorDark: "white" }}
              newWindow
            />
          </Text>
        </Tooltip>
      )}
    </>
  );
};
